/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/content/content',
	'../nls/StringResources',
	'react',
	'react-dom'
], function (content, StringResources, React, ReactDOM) {

	const MYFOLDERS_ID = '.my_folders';

	class ContentPageView {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.el = (options.$el && options.$el[0]) || this._initDomElement();
			this.tab = options.tab;
			this.folder = options.folder;
			this.logger = this.glassContext.getCoreSvc('.Logger');
			this.eventRouter = this.glassContext.getCoreSvc('.Events');
			this.uploadHelper = new content.UploadHelper({ glassContext: this.glassContext });
		}

		_getFolderData(folderPathRef) {
			const options = {
				dataType: 'json',
				type: 'GET',
				url: content.ContentServiceUrls.getPathURL(folderPathRef),
				data: {
					'fields': 'type,ancestors'
				}
			};
			return this.glassContext.getCoreSvc('.Ajax').ajax(options).then((objInfo) => {
				const folder = objInfo.data.data[0];
				if (this._isTopLevel(folder)) {
					return {
						tab: this.tab || (folder.type === 'content' ? 'teamContent' : 'myContent')
					};
				} else {
					return {
						tab: this.tab || (folder.ancestors[0].type === 'content' ? 'teamContent' : 'myContent'),
						folder: folder.type === 'folder' ? folderPathRef : folder.ancestors.pop().id
					};
				}
			}).catch((error) => {
				this.logger.error('Failed to retrieve objInfo for pathRef=' + folderPathRef, error);
				return Promise.resolve({ tab: this.tab });
			});
		}

		_isTopLevel(objInfo) {
			return objInfo.ancestors.length > 0 ? objInfo.ancestors.filter(ancestor => ancestor.type === 'folder' || ancestor.type === 'content' || ancestor.id === MYFOLDERS_ID).length === 0 : true;
		}

		getFolderInfo() {
			return this.folder ? this._getFolderData(this.folder) : Promise.resolve({ tab: this.tab });
		}

		render() {
			return this.getFolderInfo().then((folderInfo) => {
				return this.uploadHelper.initialize().then(() => {
					const options = {
						glassContext: this.glassContext,
						tab: folderInfo.tab,
						folder: folderInfo.folder,
						uploadHelper: this.uploadHelper,
						onBrowserNavigate: this.updatePerspectiveContext.bind(this)
					};
					ReactDOM.render(React.createElement(content.ContentPageView, options), this.el);
					return Promise.resolve();
				});
			});
		}

		activate(content) {
			this.updateContentPage(content);
			return Promise.resolve();
		}

		deactivate() {
			return Promise.resolve();
		}

		show() {
			this.el.setAttribute('style', 'display: block;');
			this.eventRouter.trigger('content:refresh');
		}

		setFocus() { }

		_initDomElement() {
			const el = document.createElement('div');
			el.classList.add('contentPageView');
			return el;
		}

		getTitle() {
			return StringResources.get('contentPageTitleLabel');
		}

		updatePerspectiveContext(context, options) {
			const isContentUpdated = this.updateContentPage(context.content, options);
			this.glassContext.currentPerspective.updateRenderState(!isContentUpdated);
		}

		updateContentPage(content, options = {}) {
			if (this.tab !== content.tab || this.folder !== content.folder) {
				this.tab = content.tab;
				this.folder = content.folder;
				if (!options.silentUpdate) {
					this.render();
				}
				return true;
			}
			return false;
		}

		getContent() {
			return {
				tab: this.tab,
				folder: this.folder
			};
		}
	}

	return ContentPageView;
});